module.exports = __webpack_public_path__ + "static/media/YF11_1.147a24c6.jpg";